import { useState } from 'react';
import { Box, MenuItem, TextField, Typography } from '@material-ui/core';
import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import HelpIcon from '@material-ui/icons/Help';
import { AGENT_VIRTUAL_2K_MODEL, AGENT_VIRTUAL_3K_MODEL, AGENT_VIRTUAL_290_MODEL } from './AgentConstants';
import { RowFlexLayout } from '../../layout';
import { useHelpUrl } from '../../../utilities/HelpUtilities';

const whatIsAnAgentHelpTip = i18n._(t`View help documentation regarding nPoint Models`);
const fieldLabel = 'nPoint Model';
const agent2kText = i18n._(t`nPoint 2000V`);
const agent2kHelpText = i18n._(t`The nPoint 2000V supports 100 Service Tests`);
const agent3kText = i18n._(t`nPoint 3000V`);
const agent3kHelpText = i18n._(
    t`The nPoint 3000V supports 300 Service Tests as well as Business Transaction Tests (BTT)`
);
const agent290Text = i18n._(t`Edge Sensor 290`);
const agent290HelpText = i18n._(
    t`The Edge Sensor 290 supports 300 Service Tests as well as Business Transaction Tests (BTT)`
);

/** @param {import('./AgentDownloadDialog').WizardProps} props */
export default function AgentDownloadWizardModel({ wizardSelections }) {
    const [modelSelection, setModelSelection] = useState(wizardSelections.current.model);
    const whatIsAnAgentHelp = useHelpUrl('WhatisannPoint');

    const handleChange = (e) => {
        wizardSelections.current.model = e.target.value;
        setModelSelection(e.target.value);
    };

    return (
        <>
            <RowFlexLayout vCenter>
                <TextField select label={fieldLabel} value={modelSelection} onChange={handleChange}>
                    <MenuItem value={AGENT_VIRTUAL_290_MODEL}>{agent290Text}</MenuItem>
                    <MenuItem value={AGENT_VIRTUAL_3K_MODEL}>{agent3kText}</MenuItem>
                    <MenuItem value={AGENT_VIRTUAL_2K_MODEL}>{agent2kText}</MenuItem>
                </TextField>
                <Box ml={2} mt={2}>
                    <a href={whatIsAnAgentHelp} target="_blank" rel="noreferrer" title={whatIsAnAgentHelpTip}>
                        <HelpIcon fontSize="small" />
                    </a>
                </Box>
            </RowFlexLayout>

            <Box mt={2} mb={2} width={550}>
                <Typography variant="caption" gutterBottom>
                    {modelSelection === AGENT_VIRTUAL_3K_MODEL && agent3kHelpText}
                    {modelSelection === AGENT_VIRTUAL_2K_MODEL && agent2kHelpText}
                    {modelSelection === AGENT_VIRTUAL_290_MODEL && agent290HelpText}
                </Typography>
            </Box>
        </>
    );
}
